import React, { useState } from "react";
import InnerBanner from "../../common/InnerBanner";
import "../../styles/about.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import data from "../../json/index.json";

const AboutPg = () => {
  const [activeCard, setActiveCard] = useState("");
  return (
    <div>
      <InnerBanner name="About Us" />
      <div className="about_us_pg">
        <div className="container about_us_main">
          <div className="about_us_img">
            <img src="/img/about.webp" alt="about img" />
          </div>
          <div className="about_us_content dm-sans">
            <h1>Fresh Food, Simply Deliciuos</h1>
            <p className="">
              Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
              posuere cubilia Curae; Maecenas venenatis posuere volutpat. Mauris
              laore Sed non sem blandit, ultrices nisl et, auctor purus. Nunc
              quam diam, vehicula in metus quis, pulvinar finibus tortor
            </p>
            <button className="flex-center">
              <i className="bi bi-play-fill"></i>
            </button>
          </div>
        </div>
        <div className="about_us_features">
          {["bi-truck", "bi-gift", "bi-lock", "bi-headset"].map((item) => (
            <div
              className="flex-col-center dm-sans"
              onMouseOver={() => setActiveCard(item)}
              onMouseOut={() => setActiveCard("")}
            >
              <i
                class={`bi ${item} animate__animated ${
                  activeCard === item ? "animate__zoomIn" : ""
                }`}
              ></i>
              <h6>Freeship Wordwide</h6>
              <span>
                In ac hendrerit turpis.aman singh Aliquam ultrices dolor dolor,
                at commodo diam feugiat
              </span>
            </div>
          ))}
        </div>
        <div className="about_team_members flex-col-center dm-sans container ">
          <h2 className="section-title">Team Members</h2>
          <div className="about_team_members_slider overflow-hidden w-100 flex-center">
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 2500, disableOnInteraction: true }}
              loop={true}
              spaceBetween={50}
              slidesPerView={4}
              allowSlideNext={true}
              allowSlidePrev={true}
              className="flex-center"
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                600: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },

                1024: {
                  slidesPerView: 4,
                  spaceBetween: 50,
                },
              }}
            >
              {data.testimonial.map((slide) => (
                <SwiperSlide key={slide.id} role="button">
                  <div className="animate__animated animate__fadeInLeft text-black-50 flex-col-center">
                    <img src={slide.img_url} alt={slide.name} />
                    <h5 className="mt-2 text-bold font-weight-bold">
                      {slide.name}
                    </h5>
                    <span>{slide.professtion}</span>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="client_say_members flex-col-center dm-sans ">
          <h2 className="section-title">What Clients Say ?</h2>
          <div className="client_say_members_slider overflow-hidden w-100 flex-center">
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 2500, disableOnInteraction: true }}
              loop={true}
              spaceBetween={50}
              slidesPerView={1}
              allowSlideNext={true}
              allowSlidePrev={true}
              className="flex-center container"
            >
              {data.testimonial.map((slide) => (
                <SwiperSlide key={slide.id} role="button">
                  <div className="text-black-50 flex-col-center">
                    <img
                      src="/img/testimonials/testimonial-shape.webp"
                      alt={slide.name}
                    />
                    <h5 className="mt-2 text-bold font-weight-bold text-center">
                      {slide.review}
                    </h5>
                    <img
                      className="testmonial-user"
                      src={slide.img_url}
                      alt={slide.name}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="client_say_members flex-col-center dm-sans ">
          <div className="brands_slider overflow-hidden w-100 flex-center">
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 2500, disableOnInteraction: true }}
              loop={true}
              spaceBetween={30}
              slidesPerView={5}
              allowSlideNext={true}
              allowSlidePrev={true}
              className="flex-center container"
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                480: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 50,
                },
              }}
            >
              {data.testimonial.map((slide) => (
                <SwiperSlide
                  key={slide.id}
                  role="button"
                  className="flex-center"
                >
                  <img src="img/brands/one.webp" alt={slide.name} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPg;
